
import { Enums } from '../common/enums'

import { ICopyable, IOpData } from '../util/interfaces'

import { OpDataType } from '../core/op-data-type'
import { OpTariff } from '../core/op-tariff'



export class OpTariffData implements IOpData, ICopyable<OpTariffData> {

    // #region Properties

    public idTariffData: number
    public idTariff: number
    public idDataType: number
    public value: any
    public indexNbr: number

    // #endregion


    // #region NavigationProperties

    public tariff: OpTariff
    public dataType: OpDataType

    // #endregion NavigationProperties


    // #region Custom Properties

    public previousValue: any // Na backendzie to jest typu object

    // #endregion
    

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion
    

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IOpData

    public get idData() { return this.idTariffData }
    public set idData(idData: number) { this.idTariffData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // #endregion


    // #region IJsonSerializable

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idTariffData = opObj.ID_TARIFF_DATA
            this.idTariff = opObj.ID_TARIFF
            this.idDataType = opObj.ID_DATA_TYPE
            this.value = opObj.VALUE
            this.indexNbr = opObj.INDEX_NBR

            this.tariff = opObj._Tariff != null ? new OpTariff(opObj._Tariff) : null
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        } else {
            this.idTariffData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_TARIFF_DATA: this.idTariffData,
            ID_TARIFF: this.idTariff,
            ID_DATA_TYPE: this.idDataType,
            VALUE: this.value,
            INDEX_NBR: this.indexNbr,
            OpState: this.opState != null ? this.opState : null
        }
    }

    // endregion


    public static fromIOpData(data: IOpData): OpTariffData {
        const newData: OpTariffData = new OpTariffData(null)

        newData.idTariffData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTariffData {
        const tariffData: OpTariffData = new OpTariffData(null)

        tariffData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return tariffData
    }

    public copy(source: OpTariffData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.dataType = source.dataType != null ? source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            this.previousValue = source.previousValue
        }

        if (includeDataList) {
            // No Data list
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idTariffData = source.idTariffData
        this.idTariff = source.idTariff
        this.idDataType = source.idDataType
        this.value = source.value
        this.indexNbr = source.indexNbr

        this.opState = source.opState
    }

    // # endregion
}